module.exports = __webpack_public_path__ + "static/assets/cc0255360a4a80c094a9d454c8e734f4.png";